// extracted by mini-css-extract-plugin
export default {"nexarrivals":"Wishlish_nexarrivals__kWmDa","pcontainer":"Wishlish_pcontainer__InVkl"};